var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"card-list-item"},[_vm._t("default",null,{"data":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }